import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { PenLine } from 'lucide-react'
import { useState } from 'react'

import { TaskFormDialog } from '@/components/tasks/TaskCreator'
import { Task } from '@/store/task'

export function TaskEditor({ task }: { task: Task }) {
  const { tc } = useT()
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
        <PenLine className="size-4" /> {tc('edit', { cfl: true })}
      </Button>
      {open && <TaskFormDialog modalHandler={{ open, setOpen }} editableTask={task} />}
    </>
  )
}
